// Use stable subject identity when restoring browser state saved before the numbering correction.
// Do not swap arbitrary numeric levels: HSK and already-corrected CSCA state must stay unchanged.
export function normalizeStoredCscaSubject<T extends { level: number; part?: string; questions?: any[]; paperId?: string }>(test: T): T {
  const ids = [test.paperId, ...(test.questions || []).map(q => q.id || q.question_id)];
  const level = test.part === 'chinese-stem' || ids.some(id => String(id || '').startsWith('CSCA_IPA_')) ? 2
    : test.part === 'chinese-humanities' || ids.some(id => String(id || '').startsWith('CSCA_IPS_')) ? 1 : null;
  if (level == null) return test;
  return { ...test, level, questions: test.questions?.map(q => ({ ...q, level })) };
}
